import type { Language } from "./languages"

/**
 * Language display names in their OWN language (never translated) — the a11y
 * convention for language switchers ("Deutsch", not "German"). Keyed by the
 * supported Language union so adding a language is a compile error until named.
 */
export const LANGUAGE_NATIVE_NAME: Record<Language, string> = {
  en: "English",
  de: "Deutsch",
}

export const nativeLanguageName = (lang: Language): string =>
  LANGUAGE_NATIVE_NAME[lang]
